var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("div", { staticClass: "banner-container" }, [
          _c("img", {
            staticClass: "banner-image",
            staticStyle: { opacity: "0.5" },
            attrs: {
              loading: "lazy",
              src: _vm.currentBannerImage,
              alt: "banner"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "banner-text-container" },
            [_c("search-section", { attrs: { "is-home-page": true } })],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb80db54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb80db54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/topImageSection.vue
// module id = null
// module chunks = 